import $ from 'jquery';

class RestorationSolutions {
  constructor() {
    // this.elements = $('.js-brs-stage-half');
    this.elements = $('.js-brs-box');
    this.offset = 140;

    if (!this.elements.length) {
      return;
    }

    $(window).on('load scroll', () => {
      this.showStages();
    });
  }

  showStages() {
    this.topOffset = $(window).scrollTop();
    this.windowHeight = $(window).height();

    this.elements.each((index, element) => {
      const self = $(element);

      if (
        self.offset().top <=
        this.topOffset + this.windowHeight - this.offset
      ) {
        self.addClass('is-in-view');
      } else {
        self.removeClass('is-in-view');
      }
    });
  }
}

export default new RestorationSolutions();



// WEBPACK FOOTER //
// ./src/scripts/modules/restoration-solutions.js